import React from 'react';
import { toast } from 'react-hot-toast';
import arafat from '../assets/images/arafat.jpg';
import imrul from '../assets/images/imrul.jpg';
import zia from '../assets/images/ziaur-titus.jpg';
import hydaline from '../assets/images/hydaline.jpg';

function Team() {
  const devTeamMembers = [
    {
      name: 'ZIAUR TITUS',
      id: '2',
      role: 'Senior Database Architect',
      image: zia,
      linkedin: '#',
      facebook: '#',
      description: 'Creating efficient and scalable database architectures for our applications.',
      country: 'Bangladesh',
    },
    {
      name: 'MD ARAFAT HOSSAIN',
      id: '1',
      role: 'Project Manager & Full Stack Developer',
      image: arafat,
      linkedin: 'https://www.linkedin.com/in/md-arafat-hossain-a39398379/',
      twitter: 'https://x.com/Hossain_WebDev',
      facebook: 'https://www.facebook.com/hossainArafUtech/',
      github: 'https://github.com/HossainAraf',
      description: 'Leading our projects with expertise in both management and full-stack development.',
      country: 'Bangladesh',
    },
    {
      name: 'IMRUL HASAN',
      id: '3',
      role: 'Software Developer',
      image: imrul,
      linkedin: '#',
      facebook: '#',
      description: 'Building innovative software solutions with clean code and modern practices.',
      country: 'Bangladesh',
    },
    {
      name: 'Hydaline C.',
      id: '4',
      role: 'Full Stack Developer',
      image: hydaline,
      linkedin: '#',
      twitter: 'https://x.com/hydalineC',
      github: 'https://github.com/hydaline-code?tab=repositories',
      description: 'Building innovative software solutions with clean code and modern practices.',
      country: 'Cameroon',
    },
  ];

  const handleSubmit = () => {
    // open a toast notification
    toast.success('No job position is currently open. Please check back later!', {
      duration: 5000,
      position: 'top-center',
      style: {
        background: '#1a202c',
        color: '#fff',
        borderRadius: '8px',
        border: '1px solid #6b46c1',
      },
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
            Meet Our Team
          </h1>
          <p className="mt-4 text-xl text-gray-300 max-w-3xl mx-auto">
            We are a group of dedicated professionals committed to delivering exceptional solutions
            at UTech Dynamics.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {devTeamMembers.map((member) => (
            <div key={member.id} className="bg-gray-800 rounded-xl overflow-hidden border border-gray-700 transition-all duration-300 hover:shadow-2xl hover:border-purple-500 flex flex-col">
              <div className="h-48 bg-gradient-to-r from-blue-600 to-purple-600 relative">
                <div className="absolute -bottom-16 left-1/2 transform -translate-x-1/2">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-32 h-32 rounded-full border-4 border-gray-800 object-cover shadow-lg bg-gray-700"
                  />
                </div>
              </div>

              <div className="pt-20 pb-6 px-6 text-center flex-grow">
                <h2 className="text-2xl font-bold">{member.name}</h2>
                <p className="text-purple-400 mt-2">{member.role}</p>
                <p className="text-gray-400 mt-4 text-sm">{member.description}</p>
                <p className="text-gray-300 mt-2 text-xs italic">{member.country}</p>

                <div className="flex justify-center space-x-3 mt-6">
                  {member.linkedin && member.linkedin !== '#' && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 flex items-center justify-center rounded-full bg-blue-600 hover:bg-blue-500 transition-colors duration-300"
                      aria-label={`${member.name} LinkedIn`}
                    >
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                      </svg>
                    </a>
                  )}

                  {member.facebook && member.facebook !== '#' && (
                    <a
                      href={member.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 flex items-center justify-center rounded-full bg-blue-700 hover:bg-blue-600 transition-colors duration-300"
                      aria-label={`${member.name} Facebook`}
                    >
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                      </svg>
                    </a>
                  )}

                  {member.github && (
                    <a
                      href={member.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-gray-700 transition-colors duration-300"
                      aria-label={`${member.name} GitHub`}
                    >
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                      </svg>
                    </a>
                  )}

                  {member.twitter && (
                    <a
                      href={member.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 flex items-center justify-center rounded-full bg-blue-400 hover:bg-blue-300 transition-colors duration-300"
                      aria-label={`${member.name} Twitter`}
                    >
                      <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16 p-8 bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl border border-gray-700">
          <h2 className="text-3xl font-bold mb-4">Want to join our team?</h2>
          <p className="text-gray-300 max-w-2xl mx-auto mb-6">
            We&#39;re always looking for talented individuals to join our growing team
            at UTech Dynamics.
          </p>
          <button
            type="button"
            onClick={handleSubmit}
            className="bg-purple-600 hover:bg-purple-700 text-white font-medium py-3 px-8 rounded-lg transition duration-300 transform hover:-translate-y-1"
          >
            View Open Positions
          </button>
        </div>
      </div>
    </div>
  );
}

export default Team;
